// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__Exfew","file":"styles_file__afnrM"};